import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { VendorDTO, getVendorById } from 'wisestep-api';
import { WsTitleBanner, FormWizard } from 'wisestep-base';

import Loader from '../../../features/conversationWidget/components/Loader';

import VendorDetailsForm from './VendorDetailForm';

const VendorForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [formWizardCurrentStep, setFormWizardCurrentStep] = useState(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [vendor, setVendor] = useState<VendorDTO | null>(null);
  const onFormWizardArrowClick = () => navigate('/vendorslist');

  const formWizardMenuItemClick = (id: number) => {
    setFormWizardCurrentStep(id);
  };

  useEffect(() => {
    const fetchVendorDetails = async () => {
      setLoading(true);
      try {
        if (params.vendorId) {
          const response = await getVendorById(params.vendorId);
          setVendor(response.data);
        }
      } catch (error) {
        console.error('Error fetching vendor details:', error);
      } finally {
        setLoading(false);
      }
      setLoading(false);
    };
    fetchVendorDetails();
  }, [params.vendorId]);

  const menuItems = [
    {
      id: 0,
      label: 'Vendor Information',
      onClick: () => formWizardMenuItemClick(0),
    },
  ];

  return (
    <>
      <FormWizard
        menuItems={menuItems}
        onArrowButtonClick={onFormWizardArrowClick}
        currentStep={formWizardCurrentStep}
        title="Vendor List"
      >
        <WsTitleBanner title="Vendor Details" backButton={false} />
        {formWizardCurrentStep == 0 && !loading ? (
          <VendorDetailsForm vendor={vendor} />
        ) : (
          <Loader />
        )}
      </FormWizard>
    </>
  );
};

export default VendorForm;
